module.exports = __webpack_public_path__ + "img/GQ.8be10c94.svg";